import React, { useState } from "react";
import { Menu, Button, Grid, Box } from "@mui/material";
import down from "./imgs/cev-down.svg";

function FilterUpdatedOn({ setUpdatedTo, setUpdatedFrom }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [toDate, setToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const role = "1";
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const filterFun = (e) => {
    e.preventDefault();
    setUpdatedTo(fromDate);      // Correct assignment
    setUpdatedFrom(toDate);      // Correct assignment
    handleClose();
  };

  return (
    <>
      <Button
          variant="outlined"
          color="primary"
          size="medium"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          endIcon={
            <img
              src={down}
              alt="down"
              style={{ width: "14px", height: "14px", marginLeft: "4px" }}
            />
          }
          sx={{
            whiteSpace: "nowrap",            // prevent line break
            textTransform: "none",           // optional: keep "Updated On" capitalization
            fontSize: { xs: "0.8rem", sm: "1rem", md: "1rem" }, // responsive font size
            padding: { xs: "6px 10px", sm: "8px 16px", md: "5px 10px" }, // responsive padding
            minWidth: "auto",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,                          // space between text and icon
          }}
        >
          Updated On
      </Button>


      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="my-3"
      >
        <form className="row mx-2 align-items-center">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={5}>
              <input
                type="date"
                className="dateinput"
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid item xs={12} sm={2} className="text-center mt-2">
              <b>To</b>
            </Grid>
            <Grid item xs={12} sm={5}>
              <input
                type="date"
                className="dateinput"
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
                style={{ width: "100%" }}
              />
            </Grid>
          </Grid>
          <Button
            className="lastbottonfilter1 mt-5"
            variant="contained"
            color="primary"
            onClick={filterFun}
            sx={{
              backgroundColor: "#1caae8",
              "&:hover": {
                backgroundColor: "#1caae8", // Darker shades for hover
              },
              marginLeft: 'auto'
            }}
          >
            Filter
          </Button>
        </form>
      </Menu>
    </>
  );
}

export default FilterUpdatedOn;
